import * as React from "react";
import type { GatsbyBrowser } from "gatsby";
import { AuthProvider } from "./src/context/AuthContext";
import { UsageProvider } from "./src/context/UsageContext";
import { ColorModeProvider } from "./src/context/ColorModeContext";

export const wrapRootElement: GatsbyBrowser["wrapRootElement"] = ({
  element,
}) => (
  <AuthProvider>
    <UsageProvider>{element}</UsageProvider>
  </AuthProvider>
);

// The theme lives here rather than in wrapRootElement because Gatsby also
// wraps each page's Head in wrapRootElement; a second provider there renders
// its own CssBaseline that never hears about toggles and overrides the page.
export const wrapPageElement: GatsbyBrowser["wrapPageElement"] = ({
  element,
}) => <ColorModeProvider>{element}</ColorModeProvider>;
